export const en = {
  // NAV START
  'Home': 'MAIN',
  'Service' : 'Services',
  'Contact' : 'Contact',

  'HeroTitle' : 'inSITE MARKETING -',
  'HeroTitleSec' : 'partner for your reliable project',
  'HeroText' : 'Develop your personal brand with us. We care about your goals and work hard together with our team to provide you with the best quality. The inSITE Marketing team is very grateful for your trust in us.',
  'HeroBtn' : 'More',

  'indicatorTitle' : 'The number of our successful works',
  'indicatorTitle2' : 'SATISFIED CUSTOMERS',
  'indicatorTitle3' : 'TYPES OF SERVICES',
  'indicatorTitle4' : 'OUR EXPERIENCE',
  'indicatorYear' : 'year',

  'serviceTitle' : 'Services',
  'serviceType' : 'Web sites',
  'serviceText' : 'Create your website with us. We create different types of websites according to your desire.',
  'serviceType2' : 'Google advertising (SEO)',
  'serviceText2' : 'We will professionally advertise your site in Google and Yandex search engines.',
  'serviceType3' : 'Telegram bot',
  'serviceText3' : 'Create your Telegram bot with us. We create different types of bots according to your desire.',
  'serviceType4' : 'Web design',
  'serviceText4' : 'Web design | Creative and unique website ideas',

  'advantagesTitle' : 'Our advantages.',
  'advantagesType' : 'Experienced team members',
  'advantagesText' : 'Our team members are professionals in their field, have more than 1.5 years of experience in their field and are responsible.',
  'advantagesType2' : 'Technical support',
  'advantagesText2' : 'After the completion of the project, our employees will be monitored for 3 months.',
  'advantagesType3' : 'Affordable price and quality',
  'advantagesText3' : 'inSITE Marketing offers its clients excellent quality and affordable prices.',
  'advantagesType4' : 'Guaranteed Service',
  'advantagesText4' : 'We guarantee 100% that our service will comply with the agreement and we will provide it within the agreed time frame.',
  'advantagesType5' : 'Professional Design',
  'advantagesText5' : 'We have a professional approach to design, the design is unique and not a copy.',
  'advantagesType6' : 'creative ideas',
  'advantagesText6' : 'Our team shares new ideas and proposals in the process of cooperation.',
 
  'accordionTitle' : 'FAQ',
  'accordionType' : 'What is needed to create a website?',
  'accordionText1.1' : 'To get started you will need:',
  'accordionText1.2' : '— Logo (if any);',
  'accordionText1.3' : '— Concept (corporate colors);',
  'accordionText1.4' : '— Content for the site (images, texts, photos, videos, etc.);',
  'accordionText1.5' : '– Your wishes and requirements;',
  'accordionType2' : 'How long does it take to create a site?',
  'accordionText2' : 'The time it takes to create fully finished sites can vary and vary depending on the type of project. The launch of the simplest site takes 7 working days',
  'accordionType3' : 'Can I change the information on the site myself?',
  'accordionText3' : 'Yes, of course, you will be provided with instructions and access to the content management system, which has a very user-friendly interface, intuitive and does not require special knowledge.',
  'accordionType4' : 'What is included in technical support?',
  'accordionText2.1' : 'Daily backup;',
  'accordionText2.2' : 'Install the new version;',
  'accordionText2.3' : 'Virus protection;',
  'accordionText2.4' : 'Monitoring;',
  'accordionText2.5' : 'Update info;',
  'accordionType5' : 'Will you provide technical support after the completion of the site?',
  'accordionText5' : 'We provide FREE technical support for 3 months after submitting your site.',

  'contactToasterSend' : 'Your message has been sent, we will contact you shortly',
  'contactToasterUnSend' : 'Message not sent! Please try again😞',
  'contactTitle' : 'Connect with us',
  'contactRequest' : 'Do you have a question?',
  'contactRequestText' : 'Then complete the following sections and send to us. We will answer you as soon as possible!',
  'contactBtn' : 'Send',

  'footerServiceTitle' : 'Services',
  'footerServiceLink' : 'Create website',
  'footerServiceLink2' : 'Telegram bot',
  'footerServiceLink3' : 'Web design',
  'footerServiceLink4' : 'Advertising in Google and Yandex',
  'footerAdvantagesTitle' : 'Our advantages',
  'footerAdvantagesLink' : 'Experienced team members',
  'footerAdvantagesLink2' : 'Technical support',
  'footerAdvantagesLink3' : 'Affordable price and quality',
  'footerAdvantagesLink4' : 'Guaranteed Service',
  'footerAdvantagesLink5' : 'Professional Design',
  'footerAdvantagesLink6' : 'creative ideas',
  'footerContactPhone' : 'Connect with us',
  'footerLastText' : '© 2023 insitemarketing.uz All rights reserved',

  'servicePriceTitle' : 'Prices',
  'servicePriceLanding' : 'Landing page',
  'servicePriceLandingBonus' : 'From us to you',
  'servicePriceLandingList1' : 'Domain',
  'servicePriceLandingList2' : 'Hosting',
  'servicePriceLandingList3' : 'SSL certificate',
  'servicePriceLandingTime1' : 'Term 3 days',
  'servicePriceConsultation' : 'Free consultation',
  
  'servicePriceCatalog' : 'Site catalog',
  'servicePriceCatalogTime2' : 'Term 10/20 days',
  'servicePriceCatalogPanel' : 'Admin Panel',

  'servicePriceMagasine' : 'Internet magazine',
  'servicePriceMagasineTime' : 'Term 20/30 days',
  'servicePriceMagasineXimoya' : 'Website protection',

  'servicePriceReklamaGoogle' : 'Google',
  'servicePriceReklamaList1' : 'Analysis of your competitors',
  'servicePriceReklamaList2' : 'Site analysis + recommendations',
  'servicePriceReklamaList3' : 'Bid and budget optimization',
  'servicePriceReklamaList4' : 'Keyword selection',
  'servicePriceReklamaList5' : 'Bid and budget optimization',
  'servicePriceReklamaList6' : 'Metric connection',
  'servicePriceReklamaList7' : 'Weekly report',
  'servicePriceReklamaList8' : 'Customization time: 5-7 days',
  'servicePriceReklamaGoogleYandex2' : 'Customization time: 7-10 days',
  'servicePriceReklamaMonth' : 'per month',

  'servicePriceReklamaYandex' : 'Yandex',
  'servicePriceReklamaGoogleYandex' : 'Google + Yandex'

}